"use client";
//? Library Imports ------------------------------------------------------------>
import Image from "next/image";
// import { useRouter } from "next/navigation";
import Cookies from "js-cookie";
import { useState, useCallback, useEffect } from "react";
// import { useSelector } from "react-redux";
import { Col, Tag, Row, Spin, Space, message, Typography, Button } from "antd";
// import LoginPage from "@/components/SignUpPage/LoginPage";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import "./WishListModule.scss";
import CancelX from "../../../assets/images/CartPage/CancelX.svg";
import WishlistIcon from "../../../assets/images/CartPage/empty-cart.png";
import AccountStatus from "@/functions/Cookies/Cookies";
import AddToCartModal from "@/components/CheckoutPage/Modules/AddToCartModal/AddToCartModal";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Link from "next/link";
import { removeCommasAndConvertToNumber } from "@/functions/HelperFunctions";
import BackArrow from "../../../assets/Icons/BackArrow.svg";
import { useRouter } from "next/navigation";

const { Text } = Typography;

export default function MobileWishListModule() {
  const defaultCurrencyFromCookies = Cookies.get("defaultCurrencyName");
  const mainColor = Cookies.get("main_theme");
  const secondaryColor = Cookies.get("secondary_theme");
  // const defaultgeoLocationCountry = Cookies.get("geoLocation");
  // const defaultCountryFromCookies = Cookies.get("defaultCountry");
  const defaultCurrencyIdFromCookies = Cookies.get("defaultCurrencyId");
  const router = useRouter();

  const { loggedIn, comverse_customer_token } = AccountStatus();

  const defaultCurrency = defaultCurrencyFromCookies;
  const StoreId = defaultCurrencyIdFromCookies;

  //? States --------------------------------------------------------------------->
  const [WishlistData, setWishlistData] = useState();
  const [Loading, setLoading] = useState(false);

  const [ProductDetail, setProductDetail] = useState();
  const [ProductIndex, setProductIndex] = useState();
  const [ViewEditProductModal, setViewEditProductModal] = useState(false);

  const fetchWishlistProducts = useCallback(async () => {
    if (!loggedIn) {
      return null;
    } else
      try {
        setLoading(true);
        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const payload = {
          method: "GET",
          headers: headers,
        };

        const WishlistData = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
            `/storefront/wishlist_list?storefront=23`,
          payload
        );

        if (!WishlistData.ok) {
          throw new Error("ViewCart API Failed!");
        }

        const Products = await WishlistData.json();

        if (Products) {
          setWishlistData(Products);
          setLoading(false);
        }

        return Products;
      } catch (error) {
        // message.error("Wishlist API Failed!");
        console.error("Error fetching data:", error.message);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
  }, [comverse_customer_token, loggedIn]);

  const removeProductFromWishlist = async (productId) => {
    if (loggedIn && comverse_customer_token) {
      try {
        // setLoading(true);
        const headers = {
          "Content-Type": "application/json",
        };
        if (comverse_customer_token) {
          headers.Authorization = comverse_customer_token;
        }

        const body = {
          storefront: StoreId,
        };

        const payload = {
          method: "DELETE",
          headers: headers,
          body: JSON.stringify(body),
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND +
            `/storefront/remove_product_from_wishlist?product_id=${productId}`,
          payload
        );
        const data = await res.json();

        if (!res.ok) {
          // message.error("Failed to delete from Wishlist!");
          console.log("Failed to delete from Wishlist!");
          throw new Error("Api Failed!");
        } else {
          // setProductInWishList(false);
          message.success("Product Deleted from Wishlist!");
          setLoading(false);
          fetchWishlistProducts();
          return data;
        }
      } catch (error) {
        console.log("error", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    } else {
      // setShowLoginModal(true);
    }
  };
  useEffect(() => {
    fetchWishlistProducts();
  }, []);

  const editProduct = (product, index) => {
    setProductIndex(index);
    setProductDetail(product);
    setViewEditProductModal(true);
  };

  return (
    <Col className="SideWishList bg-white marginTop110">
      <Row
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          backgroundColor: "white",
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        <Button
          icon={
            <Image
              alt="back"
              src={BackArrow}
              width={10}
              height={10}
              preview={false}
            />
          }
          style={{
            backgroundColor: mainColor,
            color: "#ffffff",
            border: "none",
            justifyContent: "center",
            alignItems: "center",
            width: "40px",
            height: "40px",
            borderRadius: "10px",
          }}
          onClick={() => router.back()}
        />
        <Col
          className="font18 poppinsMedium"
          style={{
            flex: "1",
            fontSize: "18px",
            textAlign: "center",
          }}
        >
          Wishlist
        </Col>
      </Row>

      <Spin spinning={Loading} delay={500}>
        {WishlistData?.results?.length ? (
          <Col span={24}>
            <div
              style={{
                marginBottom: 16,
              }}
            >
              <Col span={24}>
                {WishlistData?.results?.map((wishListItem, index) => {
                  if (!wishListItem?.sold_out) {
                    const productVariant = wishListItem?.variants?.find(
                      (variant) => variant?.variant_detail?.sold_out === false
                    );
                    const discountPercentage = () => {
                      const originalPrice = removeCommasAndConvertToNumber(
                        productVariant?.variant_detail?.original_price
                      );
                      const discountedPrice = removeCommasAndConvertToNumber(
                        productVariant?.variant_detail?.discounted_price
                      );

                      if (
                        originalPrice &&
                        discountedPrice &&
                        originalPrice !== 0
                      ) {
                        const percentageOff = Math.round(
                          ((originalPrice - discountedPrice) / originalPrice) *
                            100
                        );
                        return `${percentageOff}% OFF`;
                      }

                      return "";
                    };

                    if (productVariant) {
                      return (
                        <Space
                          key={index}
                          direction="vertical"
                          className="width100 marginTop15 border padding10 marginBottom15"
                        >
                          <Space
                            style={{
                              width: "100%",
                              alignItems: "flex-start",
                              justifyContent: "space-between",
                            }}
                            key={index}
                            className="cartProductCard"
                          >
                            <Space
                              className="both gap10"
                              style={{
                                width: "100%",
                                alignItems: "flex-start",
                                justifyContent: "space-between",
                              }}
                            >
                              <img
                                width={102}
                                height={131}
                                // preview={false}
                                alt="Cart Product"
                                src={wishListItem?.images[0]?.cdn_link}
                              />
                              <Space
                                direction="vertical"
                                style={{ width: "100%" }}
                              >
                                <Text className="name font14 ">
                                  {wishListItem?.title
                                    ? wishListItem?.title
                                    : "N/A"}
                                </Text>

                                <Col flex="1 1 auto">
                                  {removeCommasAndConvertToNumber(
                                    productVariant?.variant_detail
                                      ?.discounted_price
                                  ) <=
                                    removeCommasAndConvertToNumber(
                                      productVariant?.variant_detail
                                        ?.original_price
                                    ) && (
                                    <Row
                                      align="middle"
                                      gutter={[10, 0]}
                                      style={{ overflow: "hidden" }}
                                    >
                                      <Col>
                                        <Text className="font14Bold">
                                          {defaultCurrency}
                                          &nbsp;
                                          {removeCommasAndConvertToNumber(
                                            productVariant?.variant_detail
                                              ?.discounted_price
                                          )
                                            ? removeCommasAndConvertToNumber(
                                                productVariant?.variant_detail
                                                  ?.discounted_price
                                              )
                                            : "N/A"}
                                        </Text>
                                      </Col>

                                      {removeCommasAndConvertToNumber(
                                        productVariant?.variant_detail
                                          ?.discounted_price
                                      ) <
                                        removeCommasAndConvertToNumber(
                                          productVariant?.variant_detail
                                            ?.original_price
                                        ) && (
                                        <Col>
                                          <Text className="priceCut">
                                            &nbsp;
                                            {removeCommasAndConvertToNumber(
                                              productVariant?.variant_detail
                                                ?.original_price
                                            )
                                              ? removeCommasAndConvertToNumber(
                                                  productVariant?.variant_detail
                                                    ?.original_price
                                                )
                                              : "N/A"}
                                          </Text>
                                        </Col>
                                      )}
                                    </Row>
                                  )}
                                </Col>
                                <Text className="sku font12 poppinsMedium">
                                  SKU:
                                  {productVariant?.sku
                                    ? productVariant?.sku
                                    : "N/A"}
                                </Text>

                                <DynamicButton
                                  name="Add to Cart"
                                  className="border"
                                  type="primary"
                                  size="large"
                                  function={() =>
                                    editProduct(wishListItem, index)
                                  }
                                  style={{
                                    width: "150px",
                                    display: "block",
                                  }}
                                />
                              </Space>
                            </Space>
                            <Image
                              width={14}
                              src={CancelX}
                              alt="CancelX"
                              className="cursorPointer"
                              onClick={() =>
                                removeProductFromWishlist(wishListItem?.id)
                              }
                            />
                          </Space>
                        </Space>
                      );
                    } else {
                    }
                  }
                })}
              </Col>
            </div>
          </Col>
        ) : (
          <Col className="flexColumn flexCenter marginTop60 ">
            <Image alt="Icon" width={80} height={80} src={WishlistIcon} />

            <Text
              style={{
                opacity: 1,
                color: "#000000",
                fontWeight: 100,
                fontSize: "20px",
                letterSpacing: "0px",
                fontFamily: "ZemestroStd-Medium",
                marginTop: "10px",
              }}
            >
              {`Hey! It's lonely here`}
            </Text>
            <Text
              style={{
                opacity: 1,
                color: "#747474",
                fontWeight: 100,
                letterSpacing: "0px",
                fontFamily: "ZemestroStd-Medium",
              }}
            >
              Your Wishlist is empty
            </Text>

            <DynamicButton
              link="/"
              name="Shop Now"
              className="primary_btn_outline marginTop30"
            />
          </Col>
        )}
      </Spin>

      {ViewEditProductModal ? (
        <AddToCartModal
          Loading={Loading}
          setLoading={setLoading}
          ProductIndex={ProductIndex}
          ProductDetail={ProductDetail}
          fetchWishlistProducts={fetchWishlistProducts}
          ViewEditProductModal={ViewEditProductModal}
          setViewEditProductModal={setViewEditProductModal}
        />
      ) : null}
    </Col>
  );
}
